















































import Vue from 'vue'
import { computed, defineComponent, ref, reactive } from '@vue/composition-api'
import { Message } from 'element-ui'
import { KisweButton, KisweModal, ValidationErrors } from '@/modules/kisweui/components'
import UserProfileForm, { UserProfileValidators } from '../UserProfileForm'
import { useUserProfile } from '../../compositions'
import { KeyDict } from '@/types'
import './UserProfileFormModal.scss'

export default defineComponent({
  name: 'UserProfileFormModal',
  components: {
    KisweButton,
    KisweModal,
    UserProfileForm,
    ValidationErrors
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Edit team member'
    },
    userId: {
      type: String,
      required: true
    }
  },
  emits: {
    close () { return true }
  },
  /* eslint-disable max-lines-per-function */
  setup (props, { emit }) {
    const userId = computed(() => props.userId)
    const { requestCasterRepublish, saveUserProfile, setNeedsRepublishing,
      ...restUserProfileCompositions } = useUserProfile(userId)
    const isRestartStreamDisabled = ref(true)
    const warningMessage = ref<KeyDict<string>>({})
    const validators = reactive({}) as UserProfileValidators

    const disableRestartStream = (disabled: boolean) => {
      setNeedsRepublishing({ user_id: userId.value, val: !disabled })
      isRestartStreamDisabled.value = disabled
      const message = disabled ? '' : 'Restart the stream to activate the changes.'
      updateWarningMessage({ key: 'restartStream', message })
    }

    const requestRestartStream = async () => {
      try {
        await requestCasterRepublish(userId.value)
      } catch (error) {
        console.error(error)
        Message.error('Could not republish stream')
      }
    }

    const submitted = async () => {
      try {
        await saveUserProfile()
      } catch (error) {
        console.error(error)
        Message.error('Could not update profile')
      } finally {
        close()
      }
    }

    const updateWarningMessage = (newWarning: { key: string, message: string }) => {
      if (newWarning.message === '') {
        Vue.delete(warningMessage.value, newWarning.key)
      } else {
        Vue.set(warningMessage.value, newWarning.key, newWarning.message)
      }
    }

    const updateValidatorError = (newValidators: UserProfileValidators) => {
      validators.profile = newValidators.profile
      validators.role = newValidators.role
      validators.encoder = newValidators.encoder
    }

    const close = () => {
      emit('close')
    }

    return {
      ...restUserProfileCompositions,
      close,
      disableRestartStream,
      warningMessage,
      isRestartStreamDisabled,
      requestRestartStream,
      setNeedsRepublishing,
      submitted,
      updateWarningMessage,
      updateValidatorError,
      validators
    }
  }
})
